// @i18n-ignore-file
const getUserDevice = (): string => {
  const width = window.screen.width
  let screenType
  if (width <= 520) {
    screenType = 'mobile'
  } else if (width <= 820) {
    screenType = 'tablet'
  } else {
    screenType = 'desktop'
  }
  return screenType
}

export default getUserDevice
